import { useState, useEffect, useCallback } from "react";
import { Container, Row, Col } from "react-bootstrap";
import headerImg from "../assets/img/header-img.png";
import { ArrowRightCircle } from 'react-bootstrap-icons';
import 'animate.css';
import TrackVisibility from 'react-on-screen';
import Button from 'react-bootstrap/Button';
import './Banner.css';

export const Banner = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState('');
  const [delta, setDelta] = useState(100 - Math.random() * 30);
  const period = 1200;

  const tick = useCallback(() => {
    const toRotate = ["Full Stack Web Development", "Cloud & DevOps", "Modern Infrastructure"];
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta(prevDelta => prevDelta / 2);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setDelta(period);
    } else if (isDeleting && updatedText === '') {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setDelta(100 - Math.random() * 30);
    }
  }, [loopNum, isDeleting, text, period]);

  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => { clearInterval(ticker) };
  }, [delta, tick])

  return (
    <section className="banner px-2" id="home">
      <Container>
        <Row className="aligh-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                  <span className="tagline mb-4">I'M KAVEESHA DHANASEKARA</span>
                  <h2 className="responsive-subheading">Passionate about</h2>
                  <h1 className="responsive-heading">
                    <span className="txt-rotate" data-period="1000" data-rotate='[]'>
                      <span className="wrap">{text}</span>
                    </span>
                  </h1>
                  <p className="responsive-paragraph">
                    I build and deploy cloud infrastructure, automate CI/CD workflows, and bridge software engineering with reliable system operations, turning code into production-ready, scalable solutions.
                  </p>
                  <br />
                  <Button href="/Kaveesha-Dhanasekara.pdf" target="blank" variant="outline-light" style={{ padding: '6px 20px' }}>My Resume &nbsp; <ArrowRightCircle size={25} /></Button>
                </div>}
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={4}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                  <img src={headerImg} alt="Header Img" className="responsive-img" />
                </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
